var cov_1xq5c9y65j = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/styles/expose.js",
      hash = "659b5cfd5b7504f3abe4879d8415563240e3ea06",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/styles/expose.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 27
        },
        end: {
          line: 4,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var exposeLess = {};
import genaration from '../utils/classname';
export var exposeClass = (cov_1xq5c9y65j.s[0]++, genaration(exposeLess, 'expose'));